import React from "react";
import { Link } from "react-router-dom";
import { Shield, Plus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/** Floating Action Button "Crear ticket interno".
 *
 * Visible solo para personas con `is_internal_use=true`. Al hacer click navega a
 * /tickets/new?internal=1, que filtra empresas y tipos de solicitud al perímetro
 * Uso Interno.
 */
export default function InternalTicketFab() {
    const { user } = useAuth();
    if (!user?.is_internal_use) return null;

    return (
        <Link
            to="/tickets/new?internal=1"
            className="internal-fab"
            data-testid="internal-ticket-fab"
            title="Crear ticket interno"
            aria-label="Crear ticket interno"
        >
            <Shield size={16} aria-hidden="true" />
            <Plus size={14} aria-hidden="true" style={{ marginLeft: -4 }} />
            <span>Crear ticket interno</span>
        </Link>
    );
}
